<ng-container *ngIf="visible">

  <mat-progress-bar [bufferValue]="bufferValue" [mode]="mode" [value]="value" color="accent"></mat-progress-bar>

</ng-container>
